import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/comicData";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于继母与继姐漫画，你想知道的"
          description="整理读者最常问的问题，从人物设定到关系发展，一次说清。"
        />

        <div className="mt-10 flex flex-col gap-3 md:mt-12">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  open ? "border-primary-200" : "border-background-200/80"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                    {faq.q}
                  </span>
                  <span
                    className={`grid h-7 w-7 shrink-0 place-items-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-300 ${
                      open ? "rotate-45 bg-primary-100 text-primary-700" : ""
                    }`}
                  >
                    <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200/70 px-5 py-4">
                    <p className="text-sm md:text-base leading-relaxed text-foreground-700">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((faq) => ({
                "@type": "Question",
                name: faq.q,
                acceptedAnswer: { "@type": "Answer", text: faq.a },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}